import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.modal.admin.user');
import {
    OnInit,
    OnChanges,
    SimpleChanges,
    Input,
    Output,
    EventEmitter,
    HostListener
} from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-modal-admin-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.modal.admin.user/view.scss */
/* src/app/component.modal.admin.user/view.scss: no such file or directory */`],
})
export class ComponentModalAdminUserComponent implements OnInit, OnChanges {

    @Input() mode: 'create' | 'edit' = 'edit';
    @Input() userEmail: string | null = null;

    @Output() closeModal = new EventEmitter<boolean>();

    public item: any = {};
    public view: 'ready' | 'edit' = 'ready';

    public enter = false;
    public bounce = false;
    public closing = false;

    private latest = 0;

    constructor(@Inject( Service) public service: Service) { }

    @HostListener('document:keydown.escape')
    onEscKey() {
        if (!this.closing) this.close();
    }

    public async ngOnInit() {
        await this.service.init();
    }

    public async ngOnChanges(changes: SimpleChanges) {

        if (this.mode === 'edit' && this.userEmail) {
            const res = await wiz.call('userinfo', { email: this.userEmail });
            if (res.code === 200) {
                this.item = res.data;
                this.view = 'ready';
                await this.service.render();
            }
            return;
        }

        if (this.mode === 'create') {
            this.item = {};
            this.view = 'edit';
            await this.service.render();
        }
    }

    private async closeWithAnimation(result: boolean) {
        if (this.closing) return;
        this.closing = true;
        await this.service.render();
        setTimeout(async () => {
            this.closing = false;
            this.closeModal.emit(result);
            await this.service.render();
        }, 150);
    }

    public close() {
        this.closeWithAnimation(false);
    }

    public async changeStatus() {
        this.view = 'edit';
        await this.service.render()
    }

    public async save() {
        const api = this.mode === 'create' ? 'create' : 'update';
        const res = await wiz.call(api, this.item);

        if (res.code === 200) {
            this.closeWithAnimation(true);
        } else {
            await this.service.alert.error(res.data);
        }
    }

    public mobileFormat() {
        this.latest = Date.now();

        setTimeout(async () => {
            if (Date.now() - this.latest < 400) return;

            let hp = this.item.mobile;
            if (!hp) return;

            this.item.mobile = hp
                .replace(/[^0-9]/g, '')
                .replace(
                    /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                    '$1-$2-$3'
                )
                .replace('--', '-');

            await this.service.render();
        }, 400);
    }

    public async onOutsideClick() {
        if (this.bounce || this.closing) return;

        this.bounce = true;
        await this.service.render();

        setTimeout(async () => {
            this.bounce = false;
            await this.service.render();
        }, 180);
    }

    public onModalClick(event: MouseEvent) {
        event.stopPropagation();
    }
}

export default ComponentModalAdminUserComponent;